import React, { useEffect, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import ImageCarousel from '../common/ImageCarousel';
import { formatPrice } from '../../utils/priceUtils';
import { formatDate } from '../../utils/formatDate';
import { useNavigate } from 'react-router-dom';
import config from '../../config/config';
import { AppContext } from '../../context/AppContext';
import axios from 'axios';
import ConfirmationModal from '../modals/ConfirmationModal';
const PropertyListing = ({ project, handleDelete }) => {


  const [showModal, setShowModal] = useState(false);
  const [msgTitle, setMsgTitle] = useState("");
  const [message, setMessage] = useState("");
  const [icon, setIcon] = useState("");
  const [theme, setTheme] = useState("");
  const [button, setButton] = useState("");
  const [onConfirm, setOnConfirm] = useState(null);
  const token = config.getAuthToken();
  const { user } = useContext(AppContext);
  const navigate = useNavigate();
  const handlePropertyEdit = (propertyId) => {
    if (!propertyId) return;

    navigate(`/myListing/${propertyId}`);
  };
  const handlePropertyDelete = (propertyId) => {
    if (!propertyId) return;

    alert(propertyId);
  };


  const deleteListing = async (listingId, userId, token) => {
    try {
      if (listingId && userId) {
        const formData = new FormData();
        formData.append('user_id', userId);

        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/deleteListing/${listingId}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.status) {


          handleDelete(listingId)
        } else {
          console.error('Failed to delete listing:', response.data.message);
        }
      }
    } catch (error) {
      console.error('Delete API Error:', error);
    }
  };

  const handleDeleteList = (project, user, token) => {
    // alert('delete');
    setShowModal(true)
    setMsgTitle('Are you sure you want to delete Property data?')
    setMessage()
    setIcon('fa fa-info-circle')
    setTheme('gold')
    setButton('yes')
    setOnConfirm(() => () => {
      deleteListing(project?.property_id, user?.data?.id, token);
      setShowModal(false); // close modal after deletion
    });
  }

  return (
    <>

 
      {/* <div className='manage-main-area pt-4 pb-4'> */}
      {/* <div className='d-flex flex-column' style={{ width: '100%' }}> */}

        <div className="list-card p-3 mb-4" >
          <div className='d-flex listcardbox mylistingpg'>
            <ImageCarousel project={project} />
            <div className='d-grid contbox lstdatabx'>
              <div className="list-header cont-property-header">
                <div className="w-100">
                  <h3 style={{ textTransform: "capitalize", marginBottom: 0 }}>
                    {project?.property_title}
                  </h3>
                </div>

              </div>

              <div className='property-pricing mt-3'>
                <span>₹ {formatPrice(project?.property_price)}</span>
              </div>

              <p className="mb-0"><strong>{project?.property_title}</strong> </p>
              <p className="mb-0">{project?.location}</p>

              <div className="mb-0">
                {project?.buildup_area || project?.carpet_area || project?.plot_area ? (
                  <strong>
                    {project?.buildup_area || project?.carpet_area || project?.plot_area} Sq.Ft.
                  </strong>
                ) : (
                  <strong>N/A</strong>
                )}
              </div>




              <div className="builder-info1 mt-2">
                {project?.posted_on && <>
                  <div className='builderimg desk'>

                    <h5 className='d-grid gap-1 desk'>
                      <span style={{ fontSize: '10px', color: '#999' }}>
                        {project?.posted_on ? 'Posted On : ' + formatDate(project.posted_on, "MM-YYYY") : ''} </span>

                    </h5>
                  </div>
                </>}

              </div>

              <div className='listfoot'>
                <button className="btn blubtn" onClick={() => handlePropertyEdit(project?.property_id)}>Edit</button> &nbsp;
                <button className="btn orngbtn" onClick={() => handleDeleteList(project, user, token)}>Delete</button>
              </div>
            </div>
          </div>
        </div>


      {/* </div> */}
      {/* </div> */}
      {showModal && (
        <ConfirmationModal
          onClose={() => setShowModal(false)}
          title={msgTitle}
          message={message}
          icon={icon}
          theme={theme}
          button={button}
          onConfirm={onConfirm}
        />
      )}
    </>
  );
};

export default PropertyListing;
